import { AbstractControl, ValidatorFn } from '@angular/forms';

export class DateValidators {

  static dateLessThanOrEqual(dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn {
    const res = (c: AbstractControl): { [key: string]: boolean } | null => {
      const date1 = new Date(new Date(c.get(dateField1).value).toDateString());
      const date2 = new Date(new Date(c.get(dateField2).value).toDateString());
      if ((date1 !== null && date2 !== null) && date1 > date2) {
        return validatorField;
      }
      return null;
    };
    return res;
  }
}
